import { render } from "./StoreMainTile.vue?vue&type=template&id=b67817dc&scoped=true"
import script from "./StoreMainTile.vue?vue&type=script&lang=js"
export * from "./StoreMainTile.vue?vue&type=script&lang=js"

import "./StoreMainTile.vue?vue&type=style&index=0&id=b67817dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b67817dc"]])

export default __exports__